<template>
  <b-row>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.exaborganizationlead.form.title') }}:</label>
        <input v-model.lazy="filters.title" v-debounce="delay" class="form-control" type="text" placeholder="">
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <label>{{ $t('views.firm.form.tags') }}:</label>
        <multi-select @select="onSelectTag" :options="tagOptions" :selected-options="tagsFilter"></multi-select>
      </div>
    </b-col>
    <b-col v-if="opportunityOptions.length > 0" cols="12" lg="3">
      <div class="form-group">
        <label>{{ $t('views.firm.form.idOpportunity') }}:</label>
        <multi-select @select="onSelectOpportunity" :options="opportunityOptions" :selected-options="opportunityFilter"></multi-select>
      </div>
    </b-col>
    <b-col v-if="statusOptions.length > 0" cols="12" lg="3">
      <div class="form-group">
        <label>{{ $t('views.exaborganizationlead.form.idStatus') }}:</label>
        <multi-select @select="onSelectStatus" :options="statusOptions" :selected-options="statusFilter"></multi-select>
      </div>
    </b-col>
    <b-col md="3" sm="12" v-if="!idUserData">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.exaborganizationlead.form.idUserData') }}:</label><br>
        <base-select-input
          v-model="filters.idUserData"
          :search-callback="userDataSearchCallback"
          :display-values="['fullName', 'firmname1']"
          :query-param="'userdata'"
          :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
        ></base-select-input>
      </div>
    </b-col>
    <b-col md="3" sm="12">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.userdata.list.filters.state') }}:</label>
        <b-form-group>
          <b-form-radio-group
            v-model="filters.state"
            :options="radioOptions"
            buttons
            button-variant="outline-primary"
            name="radios-btn-default"
          ></b-form-radio-group>
        </b-form-group>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import addParamsToQuery from '@/utils/addParamsToQuery'
import debounce from 'v-debounce'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'
import ApiService from '@/utils/ApiService'
import { MultiSelect } from 'vue-search-select'

export default {
  name: 'EXABOrganizationLeadFiltering',
  components: {
    BaseSelectInput,
    MultiSelect
  },
  props: {
    idUserData: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      delay: 500,
      filters: this.$store.state.filters.organizationLeadsFilter,
      tagOptions: [],
      opportunityOptions: [],
      statusOptions: [],
      tagsFilter: [],
      opportunityFilter: [],
      statusFilter: [],
      radioOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ]
    }
  },
  created () {
    this.fetchTagOptions()
    this.fetchStatuses()
    this.fetchSalesOpportunities()
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        let url = 'e_x_a_b_organization_leads'
        this.getPage(addParamsToQuery(url, JSON.parse(JSON.stringify(this.filters))))
      }
    }
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    },
    clearFilters () {
      this.filters = Object.assign(this.filters, this.$store.state.filters.organizationLeadsFilterReference)
      this.tagsFilter = []
      this.opportunityFilter = []
      this.statusFilter = []
    },
    onSelectTag (items, lastSelectItem) {
      this.tagsFilter = items
      this.filters['tags.tag'] = items.map(item => {
        return item.value
      })
      this.lastSelectItem = lastSelectItem
    },
    onSelectOpportunity (items, lastSelectItem) {
      this.opportunityFilter = items
      this.filters.idSalesOpportunity = items.map(item => {
        return item.value
      })
      this.lastSelectItemOpportunity = lastSelectItem
    },
    onSelectStatus (items, lastSelectItem) {
      this.statusFilter = items
      this.filters.idStatus = items.map(item => {
        return item.value
      })
      this.lastSelectItemStatus = lastSelectItem
    },
    async fetchTagOptions () {
      let params = { pagination: false, tagType: 2 }
      const response = await new ApiService('e_x_c_m_tags', params).getResults()
      this.tagOptions = response.items.map(tag => {
        return {
          value: tag['@id'],
          text: tag.tag
        }
      })
    },
    async fetchSalesOpportunities () {
      let params = { pagination: false, state: 1 }
      const response = await new ApiService('e_x_c_m_user_data_sales_opportunities', params).getResults()
      this.opportunityOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    },
    async fetchStatuses () {
      let params = { pagination: false, state: 1 }
      const response = await new ApiService('e_x_c_m_user_data_statuses', params).getResults()
      this.statusOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    }
  },
  directives: {
    debounce
  }
}
</script>

<style scoped>

</style>
